import LogoHeader from '../LogoHeader';
import NavBar from '../NavBar';
import NavButton from '../NavButton';
import compact from 'helpers/compact';
import FollowButton from '@/components/FollowButton';
import { FollowableEntityType } from 'queries';
import ScreenSizes, { ScreenSize } from '../ScreenSizes';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import AdminBar from 'components/AdminBar';
import Link from 'components/Link';
import TextLink from '../TextLink';

export default function TeamSubNav({
  isTeamPlayerPage,
  team
}: {
  isTeamPlayerPage?: boolean;
  team: {
    id: string;
    image?: string;
    name: string;
    mascot?: string;
    level: {
      name: string;
    };
    genderSport: {
      name: string;
    };
    standing: {
      overallRecord: string;
      leagueRecord: string;
    };
    webPath: string;
    webSchedulePath?: string;
    webRosterPath?: string;
    webStandingsPath?: string;
    webRankingsPath?: string;
    webNewsPath?: string;
    webPhotosPath?: string;
    webStatsPath?: string;
    nfhsNetworkUrl?: string;
    gofanTicketingUrl?: string;
    school?: {
      id: string;
      webPath: string;
    };
    otherTeams: {
      level: {
        name: string;
      };
      webPath: string;
    }[];
    owner?: {
      id: string;
      username: string;
    };
  };
}) {
  const [{ isFanApp }] = useApplicationContainer();
  if (isFanApp) return null;

  return (
    <>
      <LogoHeader
        alt={[team.name, team.mascot].filter(compact).join(' ')}
        image={team.image}
        title={
          <>
            {team.name}
            {team.mascot && <ScreenSizes hide={ScreenSize.SMALL}> {team.mascot}</ScreenSizes>}
          </>
        }
        subTitle={`${team.level.name} ${team.genderSport.name}`}
        subText={
          <>
            {team.standing.overallRecord} Overall &#x2022; {team.standing.leagueRecord} League
          </>
        }
        right={<FollowButton entityType={FollowableEntityType.Team} entityId={team.id} />}
      />
      <NavBar>
        <NavButton href={team.webPath}>Home</NavButton>
        {team.webSchedulePath && <NavButton href={team.webSchedulePath}>Schedule</NavButton>}
        {team.webRosterPath && (
          <NavButton href={team.webRosterPath} active={isTeamPlayerPage ? true : undefined}>
            Roster
          </NavButton>
        )}
        {team.webStandingsPath && <NavButton href={team.webStandingsPath}>Standings</NavButton>}
        {team.webRankingsPath && <NavButton href={team.webRankingsPath}>Rankings</NavButton>}
        {team.webNewsPath && <NavButton href={team.webNewsPath}>News</NavButton>}
        {team.webPhotosPath && <NavButton href={team.webPhotosPath}>Photos</NavButton>}
        {team.webStatsPath && <NavButton href={team.webStatsPath}>Stats</NavButton>}
        {team.nfhsNetworkUrl && <NavButton href={team.nfhsNetworkUrl}>Watch</NavButton>}
        {team.gofanTicketingUrl && <NavButton href={team.gofanTicketingUrl}>Tickets</NavButton>}
        {team.school?.webPath && <NavButton href={team.school?.webPath}>School Hub</NavButton>}
        {team.otherTeams
          .filter(otherTeam => otherTeam.level.name === 'Varsity')
          .map(otherTeam => (
            <NavButton href={otherTeam.webPath} key={otherTeam.level.name}>
              {otherTeam.level.name}
            </NavButton>
          ))}
      </NavBar>
      <AdminBar user={team.owner}>
        <TextLink href={`/admin/teams/${team.id}`} target="_blank">
          Team Admin
        </TextLink>
        {team.school && (
          <TextLink href={`/admin/schools/${team.school.id}`} target="_blank">
            School Admin
          </TextLink>
        )}
      </AdminBar>
    </>
  );
}
